export default "__VITE_ASSET__bb11fc45__"